module.exports = __webpack_public_path__ + "static/img_1.abb2f9a8.jpg";